import React from 'react'
import {
  SecurityLogosTls,
  SecurityLogosTlsSvg,
  SecurityLogosTuevSvg,
  SecurityLogosWrapper,
} from './security-logos.styles'
import tuvSrc from '../../assets/jpg/tuv.jpg'

const SecurityLogos = () => (
  <SecurityLogosWrapper>
    <SecurityLogosTls>
      <SecurityLogosTlsSvg />
      <br />
      Höchste
      <br />
      Datensicherheit.
    </SecurityLogosTls>

    <SecurityLogosTuevSvg src={tuvSrc} alt="logo-tuv" />
  </SecurityLogosWrapper>
)

SecurityLogos.displayName = 'SecurityLogos'

export default SecurityLogos
